const initialState = {
  refreshEpisodeParticipant: false,
  key: '',
  id: '',
  dateOfBirth: '',
  gender: '',
  registration290: '',
  arsonist: '',
  cDCNumber: '',
  cCCMS: '',
  expectedEPRD: '',
  paroleRegion: '',
  paroleCounty: '',
  episodeSAPStartDate: '',
  episodeDischargeDate: '',
  referralSource: '',
  caseManager: '',
};
export default initialState;
